// The pages behind a feature flag that need a connected card (Transactions, CardSettings): otherwise
// back to the overview, as their OnGet did.
import { useFeatures } from '@qor/web-shared';
import { type ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { type CardAccount } from '../api';
import { useCardAccount } from '../account';
import { useUser } from './RequireAuth';

export type CardState = ReturnType<typeof useCardAccount> & { account: CardAccount; reference: string };

export function CardPage({
  feature,
  withTransactions = false,
  children,
}: {
  feature: string;
  withTransactions?: boolean;
  children: (card: CardState) => ReactNode;
}) {
  const user = useUser();
  const features = useFeatures(user.email);
  const reference = user.providerUserReference ?? '';
  const card = useCardAccount(reference, withTransactions);
  if (!features.loaded) return null;
  if (!features.isEnabled(feature) || !reference) return <Navigate to="/card" replace />;
  if (!card.loaded) return null;
  // only on arrival (OnGet): after an action the page stays, with its message, whatever the card says now
  if (!card.refreshed && card.account?.isConnected !== true) return <Navigate to="/card" replace />;
  if (!card.account) return null;
  return <>{children({ ...card, account: card.account, reference })}</>;
}
